import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { LocationLicenseOverviewKeys } from "modules/LocationLicenseOverview/queryKeys";
import { updateCategoryArray } from "modules/LocationLicenseOverview/utils";
import { ApiInstance } from "utils/Api";

import type { ExactCategory, ExactCategoryID, ExactCategoryLicenseID } from "models";

type CategoryLicenseUpdatePayload = {
  category: ExactCategory;
};

type CategoryLicenseUpdateResponse = {
  exact_category_id: ExactCategoryID;
  "exact-category_license_ids": ExactCategoryLicenseID[];
};

export const useSelectedCategoryLicenseUpdateMutation = () =>
  useTypedMutation<CategoryLicenseUpdatePayload, CategoryLicenseUpdateResponse>({
    mutationFn: async payload => (await ApiInstance.post("/licenses/category/update", payload, ENV.exactBaseURL)).data,
    onSuccess: ({ category }, { exact_category_id, "exact-category_license_ids": categoryLicenseIds }) => {
      const licenses = typedQueryClient.getQueryData(LocationLicenseOverviewKeys.licenses);
      if (!licenses) return;

      const updatedCategory = { ...category, id: exact_category_id, licenses: category.licenses?.map((license, idx) => ({ ...license, id: categoryLicenseIds[idx] })) };

      typedQueryClient.setQueryData(LocationLicenseOverviewKeys.licenses, { ...licenses, categories: updateCategoryArray(licenses.categories ?? [], updatedCategory) });
    }
  });
